import React, { useEffect, useRef, useState } from "react";
interface CurrencyProps {
    currency: string;
    value: any;
    countrystandard?: string;
}
const Currency: React.FC<CurrencyProps> = ({ currency, value, countrystandard = `en-US` }) => {
    const [formattedValue, setFormattedValue] = useState<string>(``);
    useEffect(() => {        
        var formattedValue = new Intl.NumberFormat(countrystandard, {
            style: `currency`,
            currency: currency,
        }).format((value? value: 0));
        setFormattedValue(formattedValue);
    }, [value]);
    
    return <span>{formattedValue}</span>;
}
export default Currency;
